import React from "react";
import "./trivvyCommonComponents.css";
import { HiOutlineUpload } from "react-icons/hi";
// Webpage and Custom text moved to Lucide outlines to match the rest of the
// Create Trivvy modal; the old hand-rolled webIcon SVG hard-coded its stroke
// colour, which made it invisible on the restyled white tiles.
import { LuGlobe, LuFileText, LuLibrary } from "react-icons/lu";
import { isMobile } from "../../utils/deviceInfo";

export default function SourceSelector({ selectedSource, onSelectSource ,totalLibraryItems}) {

  const sourceOptions = [
    {
      name: "Upload file",
      value: 1,
      icon: <HiOutlineUpload size={50} />,
    },
    {
      name: "Webpage",
      value: 3,
      icon: <LuGlobe size={50} />,
    },
    
   
  
    {
      name: "Custom text",
      value: 2,
      icon: <LuFileText size={50} />,
      subText:"(Type or cut and paste)"
    },
    {
      name: "Library",
      value: 0,
      icon: <LuLibrary size={50} />,
      disabled:totalLibraryItems === 0,
      subText:totalLibraryItems === 0 ? "(No items in library)":""
    },
  ];

  return (
    <div className="source_options_boxes_wrapper my-3">
      {sourceOptions.map((s) => {
        return (
          <div
            key={s.value}
            className={`source_options_box ${
              s.value == selectedSource ? "selected" : ""
            } ${s.disabled ? "disabled":""}`}
            onClick={() => {
              onSelectSource(s.value);
            }}
          >
            <div className="my-2">
              {s.icon}
            </div>
            <div
              style={{
                fontSize: isMobile ? "11px" : "15px",
              }}
            >
              {s.name}
            </div>
            {
              s.subText && <div className="font-11px">
              {s.subText}
            </div>
            }
            
          </div>
        );
      })}
    </div>
  );
}
